import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import ErrorAlert from "./ErrorAlert";
class CheckBoxRadioInput extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    if (this.props.render) {
      return (
        <div
          className={"form-check mx-2" + (this.props.error ? " not-valid" : "")}
          style={this.props.singleLine ? { display: "inline-block" } : {}}
        >
          <input
            type={this.props.type}
            name={this.props.name}
            className="form-check-input"
            checked={
              this.props.type === "radio" ? this.props.checked : this.props.value
            }
            value={this.props.value}
            onChange={this.props.handleChange}
            disabled={this.props.disabled}
          />
          <label className="form-check-label">{t(this.props.label)}</label>

          {this.props.hint && (
            <i className="fa fa-question-circle" aria-hidden="true">
              {this.props.hint}
            </i>
          )}
          {this.props.error && <ErrorAlert error={this.props.error} />}
        </div>
      );
    } else {
      return null;
    }
  }
}
export default withTranslation()(CheckBoxRadioInput);
